import PropTypes from 'prop-types';
// import { useRouter } from 'next/router';

import MillesimaLink from '@/components/common/MillesimaLink';
import styles from './Card4.module.scss';

export const Card4 = ({ data }) => {
	// const router = useRouter();
	const { img, contentTitle, desc, cta, alt } = data;

	// const handleClick = (link) => {
	//   router.push(link);
	// };

	return (
		<div data-test-id="card4-container">
			<MillesimaLink
				href={cta.url}
				customClassName={{ container: styles['custom-link'] }} // TODO : Remove MillesimaLink
			>
				<img
					src={img}
					alt={alt}
					// onClick={() => handleClick(cta.url)}
					className={styles.img}
					height={400}
					data-test-id="card4-img"
				/>
			</MillesimaLink>
			{desc && <div className={styles.desc} dangerouslySetInnerHTML={{ __html: desc }} data-test-id="card4-desc" />}
			<div className={styles.title} data-test-id="card4-title">
				<MillesimaLink href={cta.url} isNofollow customClassName={{ link: styles.link }} isWithoutContainer>
					{contentTitle}
				</MillesimaLink>
			</div>
			<MillesimaLink href={cta.url} isNofollow={cta.isNofollow} customClassName={{ container: styles.link }}>
				{cta.text.label}
			</MillesimaLink>
		</div>
	);
};

Card4.propTypes = {
	data: PropTypes.object,
};

export default Card4;
